import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { AuthLayout } from '../layouts/AuthLayout';

const SetupProfilePage = React.lazy(() =>
  import('../pages/SetupProfilePage').then((m) => ({ default: m.SetupProfilePage })),
);

/**
 * Post-login setup routes — require authentication (inside ProtectedRoute)
 * but outside ProfileSetupGate (user hasn't completed profile yet).
 */
export function setupRoutes() {
  return (
    <Route element={<AuthLayout />}>
      <Route path="/setup-profile" element={<SetupProfilePage />} />
      {/* Legacy redirect — keep for backwards-compat with existing invite emails */}
      <Route path="/setup-username" element={<Navigate to="/setup-profile" replace />} />
    </Route>
  );
}
